import { createAppWrap } from '../../create_app_wrap';
import setupMixin from './mixin';
import calendarController from '../../components/_calendar_controller';

const view = '[data-view="setup-info"]';
const init = () => {
    /**

     * Vueオブジェクト
     * @type {Vue|any}
     */
    createAppWrap({
        el: view,
        /**
         * ミックスインオブジェクト
         */
        mixins: [
            setupMixin
        ],
        /**
         * コンポーネント群
         */
        components: {
            // カレンダーコンポーネント
            'calendar-controller': calendarController
        },
        /**
         * 算出プロパティ
         */
        computed: {
            // カレンダー設定データ
            config_days: {
                get() {
                    return this.setup_data.shopCalendar.data;
                },
                set(value) {
                    this.setup_data.shopCalendar.data = value;
                },
            },
        },
    });
};

if (document.querySelector(view)) {
    init();
}
